import { containsEmoji } from '@app/libs/validation';

export default function validateTitle(
  value: string,
  options?: { maxLength?: number; minLength?: number; name?: string }
) {
  const filenameRegExp = /^(?!(COM[0-9]|LPT[0-9]|CON|PRN|AUX|CLOCK\$|NUL)$)[^/\\:*?"<>|]+$/i;
  let message = '';
  let success = false;

  if (!value) {
    message = `${options?.name || '문서 이름'}을 입력해주세요.`;
  } else if (!filenameRegExp.test(value)) {
    message = '사용할 수 없는 문자가 포함되어 있습니다.';
  } else if (containsEmoji(value)) {
    message = '이모지는 사용할 수 없습니다.';
  } else if (
    (options?.maxLength && value.length > options.maxLength) ||
    (options?.minLength && value.length < options.minLength)
  ) {
    message = `${options.minLength ?? 1}자 이상 ${options.maxLength}자 이내로 입력해주세요.`;
  } else {
    message = '';
    success = true;
  }

  return { message, success };
}
